module.exports = __webpack_public_path__ + "img/oxymeter_White.a42bb414.svg";